"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sportConfig_1 = require("./football/sportConfig");
const sportConfig_2 = require("./rugbyLeague/sportConfig");
const sportConfig_3 = require("./rugbyUnion/sportConfig");
exports.sportsConfig = {
    football: sportConfig_1.footballConfig,
    rugbyLeague: sportConfig_2.rugbyLeagueConfig,
    rugbyUnion: sportConfig_3.rugbyUnionConfig
};
//# sourceMappingURL=SportsConfig.js.map